<template>
    <b-overlay :show="show" rounded="sm">
        <div class="row justify-content-md-center py-3">
            <b-col md="11">
                <h5 class="mb-3 text-center">REGISTRARSE</h5>
                <ValidationObserver ref="form">
                    <b-form @submit.prevent="onSubmit" method="post" ref="register_form">
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="nombre">
                                <b-form-input v-model="name" placeholder="Nombre" class="input-rounded"></b-form-input>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="last_name">
                                <b-form-input v-model="last_name" placeholder="Apellidos" class="input-rounded"></b-form-input>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="dni">
                                <b-form-input v-model="dni" placeholder="Cédula/Pasaporte" class="input-rounded">
                                </b-form-input>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="country">
                                <select class="custom-select register-select" v-model="country" @change="addPrefix($event.target.value)">
                                    <option :value="null">País</option>
                                    <option v-for="(item, index) in countries" :key="index" :value="item.name">{{item.name}}</option>
                                </select>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="phone_number">
                                <b-form-input v-model="phone_number" type="text" v-mask="'+###-###-#####'" placeholder="+999-999-9999" :disabled="disabled" class="input-rounded">
                                </b-form-input>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                                <span class="text-danger subtitle-info float-left ml-2" v-if="code_error">El prefijo telef&oacute;nico no coincide con el pais seleccionado</span>
                                <span class="text-danger subtitle-info float-left ml-2" v-if="character_error">Debe insertar al menos 10 digitos</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="birthday">
                                <VueDatePicker v-model="birthday"
                                               placeholder="Fecha de nacimiento"
                                               no-header
                                               id="register-dp"
                                               min-date="1941"
                                               :max-date="new Date()"
                                               class="input-rounded" />
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="title">
                                <b-form-input v-model="title" placeholder="Título profesional" class="input-rounded"></b-form-input>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="sector">
                                <b-form-select v-model="sector" class="register-select">
                                    <b-form-select-option :value="null">Sector</b-form-select-option>
                                    <b-form-select-option value="Accounting">Contabilidad e impuestos</b-form-select-option>
                                    <b-form-select-option value="Business Services">Servicios empresariales/Consultoría</b-form-select-option>
                                    <b-form-select-option value="Construction">Construcción</b-form-select-option>
                                    <b-form-select-option value="Education">Educación</b-form-select-option>
                                    <b-form-select-option value="Financial Services">Servicios financieros</b-form-select-option>
                                    <b-form-select-option value="Government">Administraciones públicas</b-form-select-option>
                                    <b-form-select-option value="Insurance - Health">Salud: Pagadores y planes sanitarios</b-form-select-option>
                                    <b-form-select-option value="Healthcare - Providers">Salud (proveedores)</b-form-select-option>
                                    <b-form-select-option value="Insurance">Seguros</b-form-select-option>
                                    <b-form-select-option value="Legal">Legal</b-form-select-option>
                                    <b-form-select-option value="Healthcare/Life Sciences">Biociencias</b-form-select-option>
                                    <b-form-select-option value="Manufacturing">Fabricación</b-form-select-option>
                                    <b-form-select-option value="Real Estate - Mortgage">Hipotecas</b-form-select-option>
                                    <b-form-select-option value="Not For Profit">Sin ánimo de lucro</b-form-select-option>
                                    <b-form-select-option value="Real Estate - Commercial">Inmobiliaria - comercial</b-form-select-option>
                                    <b-form-select-option value="Real Estate - Agent">Sector inmobiliario - Residencial</b-form-select-option>
                                    <b-form-select-option value="Retail">Comercio</b-form-select-option>
                                    <b-form-select-option value="Individual">Estudiante</b-form-select-option>
                                    <b-form-select-option value="Technology">Tecnología</b-form-select-option>
                                    <b-form-select-option value="Other">Otros</b-form-select-option>
                                </b-form-select>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required" v-slot="{errors}" name="username">
                                <b-form-input v-model="username" placeholder="Usuario" class="input-rounded" v-b-popover.hover="'Credencial para acceder a la plataforma, Favor No usar Caracteres Especiales @-%-#-^-.-;-$-!'">
                                </b-form-input>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-group>
                            <ValidationProvider rules="required|min:8|regex:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)" v-slot="{errors}" name="password">
                                <b-input-group>
                                    <b-form-input class="pass-input" v-b-tooltip.hover title="Debe insertar 8 caracteres. Al menos una mayúscula, una minúscula, un número y un caracter especial" v-model="password" :type="passwordFieldType" placeholder="Contraseña">
                                    </b-form-input>
                                    <template #append>
                                        <b-input-group-text class="group-append-icon">
                                            <b-icon :icon="passwordIconType" @click="showPass" style="cursor:pointer"></b-icon>
                                        </b-input-group-text>
                                    </template>
                                </b-input-group>
                                <span class="text-danger subtitle-info float-left ml-2">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <b-form-checkbox v-model="terms_conditions" value="true"><span id="conditions" class="subtitle-info">He leido y acepto los <b-link class="icon_color" href="https://confidenceid.com/terminos-y-condiciones-de-uso/" target="_blank">t&eacute;rminos y condiciones</b-link></span></b-form-checkbox>
                        <div class="mt-4 row justify-content-center">
                            <cid-button type="submit" class="register-btn shadow" variant="danger">REGISTRARSE</cid-button>
                        </div>
                    </b-form>
                </ValidationObserver>
            </b-col>
        </div>
        <template v-slot:overlay>
            <div class="text-center">
                <b-icon icon="arrow-clockwise" animation="spin" font-scale="3" variant="info"></b-icon>
                <p class="subtitle-info">POR FAVOR ESPERE...</p>
            </div>
        </template>
    </b-overlay>
</template>

<script>
    import axios from 'axios'
    import { extend } from 'vee-validate';
    import { required, email, min, regex } from 'vee-validate/dist/rules';
    import countriesPhones from "../countriesPhones.js"

    extend('required', required);
    extend('email', email);
    extend('min', min);
    extend('regex', regex);

    extend('required', {
        message: 'Este campo es requerido'
    });

    extend('email', {
        message: 'Correo no válido'
    });

    extend('min', {
        message: 'Debe introducir al menos 8 caracteres'
    });

    extend('regex', {
        message: 'Debe insertar 8 caracteres. Al menos una mayúscula, una minúscula, un número y un caracter especial'
    });

    export default {
        name: 'register',
        data() {
            return {
                name: '',
                last_name: '',
                dni: '', /*Cédula o pasaporte*/
                email: '',
                email_confirmation: '',
                phone_number: '',
                title: '',
                sector: null,
                birthday: null,
                country: null,
                username: '',
                password: '',
                companyname: '',
                passwordFieldType: 'password',
                passwordIconType: 'eye',
                countries: countriesPhones,
                code_error: false,
                code: null,
                character_error: false,
                confirmation_error: false,
                show: false,
                locale: 'es-ES',
                disabled: true,
                terms_conditions: 0
            }
        },
        watch: {
            phone_number(value) {
                if (!value.startsWith(this.code)) {
                    this.code_error = true;
                } else {
                    this.code_error = false;
                }

                if (value.length < 13) {
                    this.character_error = true;
                } else {
                    this.character_error = false;
                }
            },
            email_confirmation(value) {
                if (value != this.email) {
                    this.confirmation_error = true;
                } else {
                    this.confirmation_error = false;
                }
            }
        },
        methods: {
            onSubmit() {
                let params = this.$route.query;
                console.log(params);
                this.$refs.form.validate().then(success => {
                    if (success && this.confirmation_error == false && this.code_error == false && this.character_error == false && this.terms_conditions == "true") {
                        this.show = true;
                        let formData = new FormData();
                        formData.append('Name', this.name);
                        formData.append('Surname', this.last_name);
                        formData.append('DNI', this.dni); /*Cédula o pasaporte*/
                        formData.append('Email', params.sendto);
                        formData.append('PhoneNumber', this.phone_number);
                        formData.append('Title', this.title);
                        formData.append('Country', this.country);
                        formData.append('Birthday', this.birthday);
                        formData.append('Sector', this.sector);
                        formData.append('Username', this.username);
                        formData.append('Password', this.password);
                        formData.append('CompanyName', params.companyName);

                        axios.post('/api/Account/Registercustomer', formData).then(response => {
                            if (response.data.LoginError) {
                                response.data.LoginError.forEach(error => {
                                    if (error == "Username" + " " + "'" + this.username + "'" + " " + "is already taken.") {
                                        this.$bvToast.toast("El usuario ya existe", {
                                            title: 'Por favor revise:',
                                            variant: 'danger'
                                        });
                                        this.show = false;
                                    }
                                    if (error == "Email" + " " + "'" + this.email + "'" + " " + "is already taken.") {
                                        this.$bvToast.toast("El correo ya existe", {
                                            title: 'Por favor revise:',
                                            variant: 'danger'
                                        });
                                        this.show = false;
                                    }
                                    if (error == "CompanyName" + " " + "'" + this.companyname + "'" + " " + "is already taken.") {
                                        this.$bvToast.toast("Esta empresa ya existe", {
                                            title: 'Por favor revise:',
                                            variant: 'danger'
                                        });
                                        this.show = false;
                                    }
                                });
                                return
                            }
                            else {
                                if (response.data.re_active) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: 'Enhorabuena',
                                        variant: 'info'
                                    });
                                    this.show = false;
                                    this.$refs.register_form.reset();
                                    return
                                }
                                this.$bvToast.toast("Se ha registrado correctamente. Revise su correo para que active su cuenta.", {
                                    title: 'Enhorabuena',
                                    variant: 'info'
                                });
                                this.show = false;
                                this.$refs.register_form.reset();
                            }
                        });
                    } else {
                        if (this.terms_conditions != "true") {
                            this.$bvToast.toast(`Debe aceptar los términos y condiciones.`, {
                                title: 'Lo sentimos:',
                                variant: 'danger'
                            });
                        }
                        this.$bvToast.toast(`Hay errores en los datos.`, {
                            title: 'Por favor revise:',
                            variant: 'danger'
                        });
                    }
                });
            },
            showPass() {
                this.passwordIconType = this.passwordIconType === 'eye' ? 'eye-slash' : 'eye'
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
            addPrefix(selected) {
                this.disabled = false;
                this.code = this.countries.find(x => x.name == selected).code;
                this.phone_number = this.code;
            }
        }
    }
</script>

<style scoped>
    h5 {
        font-weight: 700;
        color: #2e344ae6;
    }

    .subtitle-info {
        font-size: 13px;
        color: #2e344ae6;
        font-weight: 500;
    }

    .input-rounded {
        border-radius: 25px !important;
        border: 2px solid #a5aab3;
    }

    .pass-input {
        border-right: 0 !important;
        border: 2px solid #a5aab3;
        border-top-left-radius: 25px !important;
        border-bottom-left-radius: 25px !important;
    }

    .form-control::placeholder {
        font-size: 14px !important;
        color: #a5aab3 !important;
    }

    .group-append-icon {
        border-top-right-radius: 25px !important;
        border-bottom-right-radius: 25px !important;
        border-left: 0 !important;
        border: 2px solid #a5aab3;
        background-color: #ffffff;
    }

    .register-btn {
        font-size: 13px !important;
        font-weight: 600 !important;
        border-radius: 25px !important;
        height: 2rem !important;
        padding: 0 6.5rem;
    }

    .register-select {
        border-radius: 25px !important;
        border: 2px solid #a5aab3;
        font-size: 15px !important;
        color: #a5aab3 !important;
    }
</style>